import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import LoadingBanner from '../LoadingBanner/LoadingBanner'

function UploadingBannerState() {
  const t = useTranslation()

  return (
    <LoadingBanner
      title={t('viewer.banner.uploadingTitle')}
      description={t('viewer.banner.uploadingDescription')}
      wrapperClassName="uploading-banner-state"
    />
  )
}

export default memo(UploadingBannerState)
